/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Orange_Lobster_FeelInputs */

const fr_zippy_orange_lobster_feel = /** @type {(inputs: Zippy_Orange_Lobster_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusé (surchargé)`)
};

/**

* @param {Zippy_Orange_Lobster_FeelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_orange_lobster_feel = /** @type {((inputs?: Zippy_Orange_Lobster_FeelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Orange_Lobster_FeelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_orange_lobster_feel(inputs)
});